import React, { useState, useEffect } from "react";
import MyRadonInterface from "../integration/internal/MyRadon/MyRadonInterface";
import styled from "styled-components/macro";
import { rgba } from "polished";
import { NavLink, withRouter } from "react-router-dom";
import { darken } from "polished";
import PerfectScrollbar from "react-perfect-scrollbar";

import { spacing } from "@material-ui/system";

import {
  Box as MuiBox,
  Chip,
  Collapse,
  Drawer as MuiDrawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Typography,
  Grid,
} from "@material-ui/core";

import { ExpandLess, ExpandMore } from "@material-ui/icons";

import { sidebarRoutes as routes, sidebarRoutes2 } from "../routes/index";

import EQBrandLogo from "../assets/img/ecosense-white.png";
import EQLogo from "../assets/img/EQ200_Logo_wh2.png";

import "../vendor/perfect-scrollbar.css";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const List = styled(MuiList)`
  background-color: ${(props) => props.theme.sidebar.background};
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)}px;
  padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
`;

const Brand = styled(ListItem)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-right: ${(props) => props.theme.spacing(6)}px;
  justify-content: left;
  cursor: pointer;
  width: 90%;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

// const BrandIcon = styled(Logo)`
//   margin-right: ${(props) => props.theme.spacing(2)}px;
//   color: ${(props) => props.theme.sidebar.header.brand.color};
//   fill: ${(props) => props.theme.sidebar.header.brand.color};
//   width: 24px;
//   height: 18px;
// `;

// const BrandChip = styled(Chip)`
//   background-color: ${green[700]};
//   border-radius: 5px;
//   color: ${(props) => props.theme.palette.common.white};
//   font-size: 55%;
//   height: 18px;
//   margin-left: 2px;
//   margin-top: -16px;
//   padding: 3px 0;
//
//   span {
//     padding-left: ${(props) => props.theme.spacing(1.375)}px;
//     padding-right: ${(props) => props.theme.spacing(1.375)}px;
//   }
// `;

const Category = styled(ListItem)`
  padding-top: ${(props) => props.theme.spacing(4)}px;
  padding-bottom: ${(props) => props.theme.spacing(4)}px;
  padding-right: ${(props) => props.theme.spacing(7)}px;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  svg {
    color: ${(props) => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) => props.theme.sidebar.active};

    svg {
      /* color: ${(props) => props.theme.sidebar.background}; */
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    /* span { */
    /*   color: ${(props) => props.theme.sidebar.background}; */
    /* } */
  }
`;

const CategoryText = styled(ListItemText)`
  span {
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    font-weight: ${(props) => props.theme.typography.fontWeightBold};
    padding: 0 ${(props) => props.theme.spacing(4)}px;
  }

  &.${(props) => props.activeClassName} {
    color: ${(props) => props.theme.sidebar.background};
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${(props) => props.theme.spacing(17.5)}px;
  padding-top: ${(props) => props.theme.spacing(2)}px;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;

  span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.9)};
  }

  &:hover {
    background-color: ${(props) =>
    darken(0.015, props.theme.sidebar.background)};
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
    darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};
  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 28px;
  top: 8px;
  background: ${(props) => props.theme.sidebar.badge.background};

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${(props) => props.theme.sidebar.badge.color};
    padding-left: ${(props) => props.theme.spacing(2)}px;
    padding-right: ${(props) => props.theme.spacing(2)}px;
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  padding: ${(props) => props.theme.spacing(4)}px
    ${(props) => props.theme.spacing(7)}px
    ${(props) => props.theme.spacing(1)}px;
  opacity: 0.9;
  display: block;
`;

const SidebarFooter = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}px
    ${(props) => props.theme.spacing(4)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const SidebarFooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const SidebarFooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const SidebarCategory = ({
  name,
  icon,
  classes,
  isOpen,
  isCollapsable,
  badge,
  ...rest
}) => {
  return (
    <Category {...rest}>
      {icon}
      <CategoryText>{name}</CategoryText>
      {isCollapsable ? (
        isOpen ? (
          <CategoryIconMore />
        ) : (
          <CategoryIconLess />
        )
      ) : null}
      {badge ? <CategoryBadge label={badge} /> : ""}
    </Category>
  );
};

const SidebarLink = ({ name, to, badge, icon, onClick }) => {
  return (
    <Link
      button
      dense
      component={NavLink}
      exact
      to={to}
      activeClassName="active"
      onClick={onClick}
    >
      <LinkText>{name}</LinkText>
      {badge ? <LinkBadge label={badge} /> : ""}
    </Link>
  );
};

const Sidebar = ({ classes, staticContext, location, onClose, ...rest }) => {
  const isReports2 = location.pathname === "/reports" ||
    location.pathname.startsWith("/reports/") ||
    location.pathname.startsWith("/reports/analysis") ||
    location.pathname.startsWith("/report2") ||
    location.pathname.startsWith("/reports/ltreport") ||
    location.pathname.startsWith("/radon-map2");
  const activeRoutes = isReports2 ? sidebarRoutes2 : routes;

  const initOpenRoutes = () => {
    /* Open collapse element that matches current url */
    const pathName = location.pathname;

    let _routes = {};

    activeRoutes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/";

      _routes = Object.assign({}, _routes, {
        [index]: isActive || isOpen || isHome,
      });
    });

    return _routes;
  };

  const [menuConf, setMenuConf] = useState(() => {
    try {
      const cached = localStorage.getItem("web_menu_conf");
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    const fetchConf = async () => {
      try {
        const res = await MyRadonInterface.getConf();
        const menu = res?.data?.Web?.menu;
        if (menu) {
          setMenuConf(menu);
          localStorage.setItem("web_menu_conf", JSON.stringify(menu));
        }
      } catch (e) {
        console.warn("Failed to fetch conf in Sidebar:", e);
      }
    };
    fetchConf();
  }, []);

  const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes());

  const toggle = (index) => {
    // Collapse all elements
    Object.keys(openRoutes).forEach(
      (item) =>
        openRoutes[index] ||
        setOpenRoutes((openRoutes) =>
          Object.assign({}, openRoutes, { [item]: false })
        )
    );

    // Toggle selected element
    setOpenRoutes((openRoutes) =>
      Object.assign({}, openRoutes, { [index]: !openRoutes[index] })
    );
  };

  return (
    <Drawer variant="permanent" {...rest}>
      <Scrollbar>
        <List disablePadding>
          <Items>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Brand component={NavLink} to="/" button onClick={onClose}>
                <Box
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Grid item style={{ marginTop: "auto" }}>
                    <img
                      style={{
                        width: "100%",
                        height: "80px",
                        objectFit: "contain",
                      }}
                      src={EQLogo}
                      alt="ecosense logo"
                    />
                  </Grid>
                </Box>
              </Brand>
              {activeRoutes.map((category, index) => (
                <React.Fragment key={index}>
                  {category.header ? (
                    <SidebarSection>{category.header}</SidebarSection>
                  ) : null}

                  {category.children && category.icon ? (
                    <React.Fragment key={index}>
                      <SidebarCategory
                        isOpen={!openRoutes[index]}
                        isCollapsable={true}
                        name={category.id}
                        icon={category.icon}
                        button={true}
                        onClick={() => toggle(index)}
                      />

                      <Collapse
                        in={openRoutes[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        {category.children.map((route, index) => (
                          <SidebarLink
                            key={index}
                            name={route.name}
                            to={route.path}
                            icon={route.icon}
                            badge={route.badge}
                            onClick={onClose}
                          />
                        ))}
                      </Collapse>
                    </React.Fragment>
                  ) : category.icon ? (() => {
                    const isRadonMap = category.id === "Radon Map";
                    const isFindPro = category.id === "Verified Radon Pro" || category.id === "Find Radon Pro";

                    let shouldDisplay = true;
                    if (menuConf) {
                      if (isFindPro && menuConf.FindPro) {
                        shouldDisplay = menuConf.FindPro.display !== false;
                      } else if (isRadonMap && menuConf.RadonMap) {
                        shouldDisplay = menuConf.RadonMap.display !== false;
                      }
                    }

                    if (!shouldDisplay) {
                      return null;
                    }

                    let targetPath = category.path;
                    if (isFindPro && menuConf?.FindPro?.data) {
                      targetPath = menuConf.FindPro.data;
                    } else if (isRadonMap && menuConf?.RadonMap?.data) {
                      targetPath = menuConf.RadonMap.data;
                    }

                    const isExternal = category.external || isRadonMap || isFindPro;

                    return (
                      <SidebarCategory
                        isCollapsable={false}
                        name={category.id}
                        to={isExternal ? undefined : targetPath}
                        href={isExternal ? targetPath : undefined}
                        target={isExternal ? "_blank" : undefined}
                        activeClassName={isExternal ? undefined : "active"}
                        component={isExternal ? "a" : NavLink}
                        icon={category.icon}
                        exact
                        button
                        badge={category.badge}
                        onClick={onClose}
                      />
                    );
                  })() : null}
                </React.Fragment>
              ))}
            </Box>
          </Items>
        </List>
      </Scrollbar>
      <SidebarFooter>
        <Grid
          container
          style={{
            padding: 25,
          }}
        >
          <Grid item xs={10} style={{ marginTop: 3 }}>
            <img
              style={{
                width: "100%",
              }}
              src={EQBrandLogo}
              alt="ecosense logo"
            ></img>
          </Grid>
        </Grid>
      </SidebarFooter>
    </Drawer>
  );
};

export default withRouter(Sidebar);
